import { SiteNav } from "../components/SiteNav";
import { Hero } from "../components/sections/Hero";
import { Problem } from "../components/sections/Problem";
import { LeaStory } from "../components/sections/LeaStory";
import { WhyReminissing } from "../components/sections/WhyReminissing";
import { Reminiscence101 } from "../components/sections/Reminiscence101";
import { Approach } from "../components/sections/Approach";
import { MeetJohnIntro } from "../components/sections/MeetJohnIntro";
import { HowItWorks } from "../components/sections/HowItWorks";
import { ProductReveal } from "../components/sections/ProductReveal";
import { EveryLife } from "../components/sections/EveryLife";
import { PackagingShowcase } from "../components/sections/PackagingShowcase";
import { Pricing } from "../components/sections/Pricing";
import { FlexibilityOptions } from "../components/sections/FlexibilityOptions";
import { Mission } from "../components/sections/Mission";
import { Waitlist } from "../components/sections/Waitlist";
import { Footer } from "../components/sections/Footer";
import { useLenisScroll } from "../lib/useLenisScroll";

export default function Landing() {
    useLenisScroll();
    return (
        <div className="bg-[#FDFBF7] text-[#2D2B2A]" data-testid="landing-page">
            <SiteNav />
            <main>
                <Hero />
                <Problem />
                <LeaStory />
                <WhyReminissing />
                <Reminiscence101 />
                <Approach />
                <MeetJohnIntro />
                <HowItWorks />
                <ProductReveal />
                <EveryLife />
                <PackagingShowcase />
                <FlexibilityOptions />
                <Pricing />
                <Mission />
                <Waitlist />
            </main>
            <Footer />
        </div>
    );
}
